// extracted by mini-css-extract-plugin
export default {"max_width":"600px","fixed_width":"600px","max_width_var":"600","fixed_width_var":"600"};